export const siteConfig = {
  name: '夜色导航',
  tagline: '黑暗中最准确的方向指引',
  description: '夜色导航，专为夜间出行、暗光环境下的用户提供精准导航服务。无论是夜间驾车、户外探险还是城市夜行，夜色导航以低蓝光护眼模式、智能路况感知与清晰夜间地图，让你在夜色中安全抵达目的地。',
  url: 'https://www.yesedaohang.com/',
  foundingYear: '2020',
  locale: 'zh-CN',
};

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '夜间驾车', path: '/category/driving' },
  { label: '户外探险', path: '/category/outdoor' },
  { label: '城市夜行', path: '/category/city-walk' },
  { label: '导航指南', path: '/articles' },
  { label: '关于我们', path: '/about' },
];

export const features = [
  {
    id: 'low-blue-light',
    icon: 'ri-moon-clear-line',
    title: '低蓝光护眼模式',
    description: '采用专业级低蓝光显示技术，大幅降低屏幕蓝光辐射。夜间使用不刺眼，保护视力健康，长时间导航也不疲劳。',
  },
  {
    id: 'smart-road',
    icon: 'ri-radar-line',
    title: '智能路况感知',
    description: '实时监测夜间道路状况，包括施工路段、事故多发区、照明不足路段。AI算法提前预警，让夜间行车更有保障。',
  },
  {
    id: 'night-map',
    icon: 'ri-map-pin-2-line',
    title: '清晰夜间地图',
    description: '专为暗光环境优化的高对比度地图渲染引擎，关键道路信息一目了然。支持3D建筑夜景模式，辨识度极高。',
  },
  {
    id: 'safety-alert',
    icon: 'ri-alert-line',
    title: '实时安全预警',
    description: '结合大数据分析，实时推送周边安全提醒。包括野生动物出没区域、急弯陡坡预警、团雾多发路段提示等。',
  },
  {
    id: 'star-nav',
    icon: 'ri-star-line',
    title: '星光导航指引',
    description: '创新的星空参考导航模式，在无网络信号区域也可通过天文定位辅助导航。户外探险者的可靠伙伴。',
  },
  {
    id: 'night-route',
    icon: 'ri-route-line',
    title: '夜间专属路线',
    description: '基于数百万夜间出行数据训练的路线推荐引擎，智能规避照明不足、路况复杂的路段，推荐最安全的夜间路线。',
  },
];

export const categories = [
  {
    slug: 'driving',
    name: '夜间驾车导航',
    subtitle: '让每一次夜间驾驶都安心从容',
    description: '专为夜间驾驶场景打造的全方位导航解决方案。从城市道路到高速公路，从照明充足的繁华街区到路灯稀疏的乡间小道，夜色导航为驾驶者提供最可靠的夜间路线指引。',
    icon: 'ri-steering-2-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20car%20dashboard%20at%20night%20with%20navigation%20screen%20displaying%20route%2C%20dark%20ambient%20lighting%2C%20minimalist%20cockpit%20with%20warm%20amber%20accents%2C%20professional%20automotive%20photography%2C%20clean%20composition%2C%20dark%20background&width=800&height=600&seq=cat-driving-01&orientation=landscape',
    features: [
      '夜间路况实时监测与预警',
      '低蓝光导航界面护眼模式',
      '智能规避照明不足路段',
      '疲劳驾驶提醒与休息站推荐',
      '高速公路夜间专属导航模式',
    ],
  },
  {
    slug: 'outdoor',
    name: '夜间户外探险',
    subtitle: '星空之下，探索不止',
    description: '为户外爱好者设计的夜间探险导航系统。无论是夜间徒步、露营迁徙、山地骑行还是星空摄影寻点，夜色导航都能提供精准的户外定位与路线规划，让你在黑暗中自信前行。',
    icon: 'ri-landscape-line',
    image: 'https://readdy.ai/api/search-image?query=night%20hiking%20trail%20with%20headlamp%20illuminating%20forest%20path%2C%20starry%20sky%20above%2C%20adventure%20mood%2C%20minimal%20lighting%2C%20atmospheric%20outdoor%20photography%2C%20dark%20natural%20environment%2C%20warm%20trail%20light%20contrast&width=800&height=600&seq=cat-outdoor-01&orientation=landscape',
    features: [
      '离线地图与天文定位导航',
      '海拔与地形实时分析',
      '野生动植物活动区域预警',
      '露营地推荐与安全评估',
      '团队位置共享与应急求救',
    ],
  },
  {
    slug: 'city-walk',
    name: '城市夜行导航',
    subtitle: '城市的夜，由你来定义',
    description: '城市夜生活的智能导航伴侣。从夜间美食探索到文化地标打卡，从夜跑路线规划到安全回家路径，夜色导航为城市夜行者提供最贴心的出行指引，让你充分享受城市的夜晚魅力。',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20city%20street%20at%20night%20with%20warm%20street%20lamps%2C%20pedestrian%20walking%20on%20sidewalk%2C%20urban%20nightlife%20atmosphere%2C%20clean%20minimalist%20aesthetic%2C%20dark%20skyline%20with%20city%20lights%2C%20cinematic%20mood&width=800&height=600&seq=cat-city-01&orientation=landscape',
    features: [
      '夜间安全路径智能推荐',
      '24小时营业场所实时查询',
      '夜跑/夜骑专属路线规划',
      '公共交通末班车提醒',
      '夜间治安状况动态评估',
    ],
  },
];

export const articles = [
  {
    slug: 'night-driving-safety-tips',
    title: '夜间驾车安全指南：10个关键注意事项',
    excerpt: '夜间驾驶事故率是白天的三倍。本文总结了10个夜间驾车最关键的注意事项，帮助你在黑暗中安全出行。',
    content: `夜间驾驶是一项需要高度集中注意力的活动。据统计，虽然夜间车流量仅占总交通量的25%，但致命交通事故中却有近50%发生在夜间。掌握正确的夜间驾驶技巧至关重要。

<h2>1. 确保车灯系统完好</h2>
出发前务必检查前照灯、尾灯、转向灯和刹车灯是否正常工作。灯光不仅为你照亮道路，更是让其他车辆发现你的关键信号。建议定期清洁灯罩，保持灯光亮度。

<h2>2. 合理使用远近光灯</h2>
在无路灯的黑暗路段使用远光灯，但遇到对向来车或前方有车辆时，应在150米外切换为近光灯。被对向远光灯照射时，视线转向道路右侧边缘线，避免直视光源。

<h2>3. 降低车速，保持车距</h2>
夜间视力范围有限，反应时间相应延长。建议车速比白天降低10-20%，与前车保持至少4秒的安全距离。夜间超车需格外谨慎。

<h2>4. 保持挡风玻璃清洁</h2>
污渍和雾气在夜间会严重散射光线，产生眩光效应。定期清洁挡风玻璃内外两侧，确保除雾器正常工作。携带干净的微纤维布随时擦拭。

<h2>5. 避免疲劳驾驶</h2>
人体生物钟在深夜和凌晨时段自然进入疲劳期。如果感到困倦，应立即在安全地点停车休息15-20分钟。每驾驶2小时应休息一次。

<h2>6. 注意野生动物出没</h2>
许多野生动物在黄昏和黎明时段活动频繁。在农村或林区路段，注意路边的动物警示标志，降低车速，随时准备刹车。

<h2>7. 使用导航辅助</h2>
使用夜色导航等专业夜间导航工具，提前了解路况、弯道和坡度信息。夜间的视线盲区更大，导航的提前预警功能尤为重要。

<h2>8. 注意行人和非机动车</h2>
夜间行人、自行车和电动车更难被发现。经过居民区、商业区时，特别注意路边可能突然出现的行人。十字路口即使绿灯也要减速观察。

<h2>9. 准备应急装备</h2>
车内应常备反光三角警示牌、手电筒、备用电池、急救包和保暖毯。在偏远地区夜间抛锚时，这些装备可能是生命线。

<h2>10. 恶劣天气加倍小心</h2>
夜间遇上雨、雾、雪天气，能见度会急剧下降。打开雾灯（如有），进一步降低车速，增加跟车距离。能见度极低时，应驶入服务区等待天气好转。`,
    category: 'driving',
    categoryName: '夜间驾车导航',
    date: '2025-12-15',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=car%20driving%20on%20dark%20highway%20at%20night%20with%20illuminated%20dashboard%20and%20road%20lines%2C%20minimalist%20composition%2C%20warm%20amber%20dashboard%20light%2C%20dark%20surroundings%2C%20professional%20automotive%20photography&width=800&height=500&seq=article-driving-01&orientation=landscape',
  },
  {
    slug: 'best-night-hiking-routes',
    title: '2026年最值得体验的夜间徒步路线推荐',
    excerpt: '从黄山到长城，从稻城到阳朔——我们为你精选了10条最适合夜间徒步的绝美路线，每一条都能让你感受不一样的星空之美。',
    content: `夜间徒步是一种独特的户外体验。在星空下行走，感受大自然的宁静与壮美，这是白天无法体会的感动。以下是2026年最值得体验的夜间徒步路线。

<h2>1. 黄山光明顶夜爬</h2>
黄山景区开放夜爬通道，从云谷寺出发至光明顶约3小时。沿途有完善的照明设施，凌晨登顶可观日出和云海。建议使用夜色导航的离线地图模式，山间信号不稳定。

<h2>2. 北京箭扣长城星空徒步</h2>
箭扣长城未经修复的野长城段，夜晚在城墙上行走，抬头可见璀璨星河。务必结伴而行，携带头灯和足够的补给。导航在这里尤为重要，山路岔口众多。

<h2>3. 稻城亚丁牛奶海夜行</h2>
从洛绒牛场至牛奶海的路线在满月之夜美得令人窒息。雪山倒映在湖面，月光洒在草甸上。海拔较高（4500米），需提前适应。

<h2>4. 阳朔漓江月夜漫步</h2>
沿着漓江边的步道，在月光下欣赏喀斯特地貌的剪影。路线平坦轻松，适合初试夜间徒步的爱好者。全程约8公里，用时2-3小时。

<h2>5. 张家界天门山夜登</h2>
999级台阶的天门洞在夜间由灯光点缀，如通往天际的光之门。夜登天门山不仅可以避开白天的人潮，还能欣赏到独特的夜间山景。

<h2>6. 青海湖环湖夜骑</h2>
夏季的青海湖畔，夜间温度适宜，骑着自行车在环湖路上前行，银河横跨天际。360公里的环湖路线可选择部分路段体验。

<h2>7. 云南梅里雪山夜观</h2>
在飞来寺附近的高原平台上，夜间可以欣赏到梅里雪山十三峰的壮观夜景。月光洒在雪峰之上，呈现出银白色的神圣光芒。

<h2>8. 华山夜爬看日出</h2>
传统的华山夜爬路线从玉泉院出发，经过千尺幢、百尺峡等险要地段。夜间攀爬反而减少了对高度的恐惧感，凌晨抵达东峰观日出。

<h2>9. 福建武夷山九曲溪夜漂</h2>
乘坐竹筏在九曲溪上漂流，两岸的丹霞地貌在夜色中更显神秘。竹筏上配有灯笼，营造出古风意境的独特体验。

<h2>10. 四川峨眉山夜登金顶</h2>
从报国寺出发，经过清音阁、万年寺，一路夜登至金顶。沿途寺院灯火点缀，钟声悠远。登顶后等待日出的那一刻，一切都值得。`,
    category: 'outdoor',
    categoryName: '夜间户外探险',
    date: '2026-01-20',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=night%20hiking%20on%20mountain%20trail%20with%20starry%20sky%20and%20milky%20way%2C%20silhouette%20of%20hiker%20with%20headlamp%2C%20epic%20landscape%20photography%2C%20dark%20natural%20environment%2C%20minimalist%20adventure%20mood&width=800&height=500&seq=article-hiking-01&orientation=landscape',
  },
  {
    slug: 'night-running-safety-guide',
    title: '城市夜跑安全指南：路线选择与装备推荐',
    excerpt: '夜跑是都市人群最流行的健身方式之一，但安全永远是第一位的。本文为你详细讲解夜跑路线选择策略和必备安全装备。',
    content: `夜跑因其灵活的时间安排和凉爽的温度，成为越来越多人选择的运动方式。但夜间的安全隐患不可忽视。掌握正确的夜跑安全知识，才能跑得健康、跑得安心。

<h2>夜跑路线选择原则</h2>
选择夜跑路线时，以下几个因素至关重要：
- <strong>照明条件</strong>：选择路灯明亮、视线良好的路段。避免公园深处、桥下等黑暗区域。
- <strong>人流密度</strong>：适中的行人流量有助于安全，但过于拥挤影响跑步体验。选择有人但不过于拥挤的路线。
- <strong>路面状况</strong>：平坦、平整的路面减少扭伤风险。注意避开施工路段和破损路面。
- <strong>交通分离</strong>：优先选择与机动车道有隔离带的步道或绿道。

<h2>推荐夜跑路线类型</h2>
1. <strong>体育场跑道</strong>：最安全的夜跑选择，塑胶跑道对膝盖友好，照明充足，有监控覆盖。
2. <strong>滨江/河步道</strong>：风景优美，空气清新，通常有独立照明系统。
3. <strong>社区绿道</strong>：住宅区周边的城市绿道，人流量适中，安全性较高。
4. <strong>大型公园环线</strong>：选择开放至晚间的大型城市公园，沿主干道跑步。

<h2>必备夜跑安全装备</h2>
- <strong>反光运动服</strong>：上半身和鞋子都要有反光元素，让车辆在200米外就能发现你。
- <strong>LED臂灯/胸灯</strong>：主动发光装备比反光装备更可靠，照亮前方路面的同时让自己更显眼。
- <strong>手机紧急联系</strong>：提前设置好紧急联系人快捷拨号。使用夜色导航的实时位置共享功能。
- <strong>哨子/个人报警器</strong>：遇到紧急情况可发出高分贝警报声，吸引周围注意。

<h2>夜跑安全守则</h2>
- 告知家人或朋友跑步路线和预计返回时间
- 避免戴降噪耳机，保持对环境声音的警觉
- 随身携带身份证件和紧急联系信息
- 定期变换跑步路线和时间，避免形成可预测的模式
- 使用夜色导航的城市夜行模式，获取实时安全评估`,
    category: 'city-walk',
    categoryName: '城市夜行导航',
    date: '2026-02-08',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=night%20runner%20on%20city%20street%20with%20LED%20armband%20and%20reflective%20gear%2C%20urban%20park%20path%20at%20night%2C%20modern%20city%20background%2C%20fitness%20lifestyle%2C%20dark%20atmosphere%20with%20warm%20streetlights&width=800&height=500&seq=article-running-01&orientation=landscape',
  },
  {
    slug: 'night-navigation-tech',
    title: '夜间导航技术解析：从GPS到星光定位',
    excerpt: '现代夜间导航背后有哪些核心技术？本文深入浅出地为你解析低蓝光显示、AI路况预测、惯性导航等关键技术原理。',
    content: `夜间导航与白天导航有着本质区别。除了基本的GPS定位，现代夜间导航融合了多项前沿技术，确保在暗光环境下仍能提供精准可靠的服务。

<h2>低蓝光显示技术</h2>
人眼在暗光环境下，瞳孔会自然放大以接收更多光线。此时高能蓝光会直接穿透晶状体到达视网膜，造成视觉疲劳和睡眠节律紊乱。夜色导航采用专业级低蓝光显示方案，通过硬件级色彩校准和软件算法双重优化，将蓝光辐射降低至普通屏幕的30%以下。

<h2>AI智能路况预测</h2>
基于深度学习的路况预测模型，综合分析历史事故数据、天气条件、时段特征和实时交通流，提前15-30分钟预测高风险路段。系统在用户规划路线时自动标注潜在危险区域，并提供替代路线建议。

<h2>惯性导航辅助系统</h2>
当GPS信号受高楼遮挡或隧道屏蔽时，惯性导航系统（INS）通过加速度计和陀螺仪持续追踪车辆运动状态，填补GPS信号空白。夜色导航的INS算法经过专门优化，误差累积控制在合理范围内。

<h2>高精度夜间地图</h2>
与日间地图不同，夜间地图需要在低亮度下保持高辨识度。夜色导航的地图渲染引擎采用高对比度配色方案，关键道路信息使用暖色调突出显示，减少视觉搜索时间。3D建筑模型在夜间模式下自动切换为线框模式，避免遮挡重要导航信息。

<h2>多源数据融合</h2>
整合交通摄像头、路侧传感器、气象雷达和众包数据，构建多维度的夜间路况全景图。系统实时分析各数据源，在路况变化时秒级更新导航建议。

<h2>天文导航辅助</h2>
在户外探险场景中，当所有电子导航手段失效时，夜色导航的天文定位模块可根据星体位置进行粗略定位。虽然精度不及GPS，但在紧急情况下可提供关键的方向参考。`,
    category: 'driving',
    categoryName: '夜间驾车导航',
    date: '2026-03-01',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20navigation%20technology%20concept%2C%20holographic%20map%20display%20in%20dark%20environment%2C%20circuit%20board%20patterns%2C%20minimalist%20tech%20aesthetic%2C%20dark%20blue%20and%20amber%20accents%2C%20clean%20digital%20art&width=800&height=500&seq=article-tech-01&orientation=landscape',
  },
  {
    slug: 'night-photography-locations',
    title: '城市夜景摄影最佳地点推荐与导航攻略',
    excerpt: '从上海外滩到重庆洪崖洞，从广州塔到西安钟楼——跟随夜色导航的城市夜行模式，找到城市最美的夜景拍摄点。',
    content: `城市夜景摄影是近年来越来越受欢迎的创作方向。灯火辉煌的城市天际线、车流如织的光轨、历史建筑的夜间面貌，每一个画面都值得记录。以下是全国各大城市最佳夜景拍摄地点推荐。

<h2>上海 - 外滩万国建筑群</h2>
外滩是上海夜景摄影的经典机位。站在外滩观景平台上，对岸陆家嘴的摩天大楼群——东方明珠、上海中心大厦、金茂大厦尽收眼底。最佳拍摄时间：日落前后30分钟的蓝调时刻。使用夜色导航的城市夜行模式可查看实时人流密度。

<h2>重庆 - 洪崖洞</h2>
洪崖洞依山而建的吊脚楼在夜间灯火辉煌，被誉为"千与千寻"的现实版。最佳机位在千厮门大桥上，可拍摄洪崖洞全景和江面倒影。夜色导航可帮助规划避开拥堵的最佳到达时间。

<h2>广州 - 珠江新城CBD</h2>
花城广场是拍摄广州塔和珠江新城天际线的最佳位置。广州塔夜间灯光秀每30分钟一场，使用夜色导航获取准确的灯光秀时间表和最佳观赏位置。

<h2>西安 - 钟楼与城墙</h2>
西安钟楼在夜间金光璀璨，从开元商城观景平台拍摄效果最佳。城墙南门（永宁门）段的夜间灯饰尤为壮观。建议使用夜间导航规划串联多个拍摄点的最优路线。

<h2>夜景摄影出行建议</h2>
- 使用夜色导航的城市夜行模式，提前查询各拍摄点的最佳到达路线和公共交通运营时间
- 关注天气状况，通透的天气最适合夜景拍摄
- 夜间出行携带三脚架时注意平衡和安全
- 部分机位在热门时段人流密集，建议错峰出行`,
    category: 'city-walk',
    categoryName: '城市夜行导航',
    date: '2026-03-15',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20city%20skyline%20night%20photography%20with%20reflections%20on%20water%2C%20modern%20skyscrapers%20illuminated%2C%20long%20exposure%20light%20trails%2C%20professional%20urban%20photography%2C%20dark%20sky%20with%20city%20lights&width=800&height=500&seq=article-photo-01&orientation=landscape',
  },
  {
    slug: 'camping-night-navigation',
    title: '夜间露营选址与导航全攻略',
    excerpt: '如何在夜晚安全地找到露营地？需要准备哪些导航装备？本文为露营爱好者提供完整的夜间露营导航解决方案。',
    content: `夜间露营既能避开白天的炎热和人群，又能独享星空下的宁静。但夜间进入露营地需要更充分的导航准备。

<h2>夜间露营选址要点</h2>
选择夜间露营地时需要考虑以下因素：
- <strong>地势平坦</strong>：在白天光线充足时难以判断的坡度，在夜间更容易被忽视。使用夜色导航的地形分析功能确认地势。
- <strong>远离危险区域</strong>：避开河道、悬崖边缘、枯树下方和可能的落石区域。
- <strong>避风位置</strong>：利用自然地形遮挡强风。
- <strong>水源距离</strong>：距离水源50-100米为佳，既方便取水又避免潮湿。

<h2>夜间导航装备清单</h2>
- 大容量充电宝：确保手机和导航设备整晚有电
- 头灯（带红光模式）：红光不影响夜视能力
- 备用电池和太阳能充电板
- 防水地图和指南针：电子设备的终极备份
- 对讲机：团队分散时的通讯保障

<h2>夜间露营安全提示</h2>
- 天黑前确认露营地坐标，使用夜色导航标记位置
- 设置地理围栏提醒，偏离安全范围时自动报警
- 关注天气预报，夜间天气变化更难察觉
- 食物密封存放，远离帐篷，避免吸引野生动物`,
    category: 'outdoor',
    categoryName: '夜间户外探险',
    date: '2026-04-02',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=cozy%20camping%20tent%20under%20starry%20night%20sky%20with%20campfire%20glow%2C%20wilderness%20setting%2C%20warm%20ambient%20light%20from%20fire%2C%20dark%20forest%20surroundings%2C%20peaceful%20outdoor%20lifestyle&width=800&height=500&seq=article-camping-01&orientation=landscape',
  },
];

export const faqItems = [
  {
    question: '夜色导航与普通导航软件有什么不同？',
    answer: '夜色导航专为夜间场景优化。它采用专业级低蓝光显示技术保护夜间视力，配备智能夜间路况感知系统，提供高对比度夜间地图，并集成了夜间专属的安全预警和路线推荐功能。普通导航软件在暗光环境下往往存在屏幕刺眼、地图辨识度低、缺乏夜间专属功能等问题。',
  },
  {
    question: '夜色导航是否支持离线使用？',
    answer: '支持。用户可以提前下载所需区域的离线地图包，在没有网络连接的情况下也能正常使用导航功能。离线模式下，地图渲染、路线规划、安全预警等核心功能均可正常运作。对于户外探险场景，我们还提供天文定位辅助功能。',
  },
  {
    question: '低蓝光护眼模式会影响导航信息的可读性吗？',
    answer: '不会。夜色导航的低蓝光模式并非简单地降低屏幕亮度或叠加黄色滤镜。它采用硬件级色彩校准和软件算法双重优化，在减少蓝光辐射的同时，通过高对比度配色方案确保导航信息的清晰可读。关键导航元素使用暖色调突出显示，兼顾护眼与实用性。',
  },
  {
    question: '夜间安全预警功能的数据来源是什么？',
    answer: '安全预警数据来自多个渠道：交通部门公开的事故数据、用户众包的实时路况反馈、气象部门的天气预警、以及我们的AI模型基于历史数据预测的潜在风险区域。所有数据经过交叉验证后，以非侵入式的方式推送给用户。',
  },
  {
    question: '如何下载和使用夜色导航？',
    answer: '夜色导航目前支持iOS和Android两大平台。您可以在App Store或各大安卓应用商店搜索"夜色导航"下载。下载后根据指引完成初始设置，授予必要的位置权限即可开始使用。基础功能免费，高级功能（如离线地图、天文导航等）需要订阅专业版。',
  },
  {
    question: '夜色导航的定位精度如何？在隧道和高楼区域表现怎样？',
    answer: '在开阔区域，夜色导航的定位精度可达3-5米。在隧道、高楼密集区等GPS信号受限的环境中，我们的惯性导航辅助系统会自动启用，通过加速度计和陀螺仪持续追踪运动轨迹，确保不中断的导航体验。在GPS信号恢复后，系统会自动校准修正误差。',
  },
  {
    question: '夜间户外探险遇到紧急情况怎么办？',
    answer: '夜色导航内置一键求救功能。在紧急情况下，系统会自动发送当前位置坐标和预设的紧急信息给你的紧急联系人。专业版用户还可以使用卫星短信功能（需硬件支持），在完全没有手机信号的偏远地区发送求救信号。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '张明远',
    role: '长途货车司机',
    content: '做了十年夜班货运，夜色导航是我用过最好的夜间导航。低蓝光模式真的让眼睛舒服很多，以前用其他导航开到半夜眼睛又干又涩，现在好多了。路线推荐也很靠谱，避开了不少照明不好的小路。',
    rating: 5,
  },
  {
    id: 2,
    name: '李雨桐',
    role: '户外探险博主',
    content: '作为一个经常夜爬、夜摄的户外博主，夜色导航简直是我的救星。离线地图和天文定位功能在深山里特别实用，团队位置共享功能让我们团队的夜间活动安全系数大大提升。',
    rating: 5,
  },
  {
    id: 3,
    name: '王建国',
    role: '城市夜跑爱好者',
    content: '每天晚上都要跑10公里，安全路线推荐功能太实用了。哪些路段晚上照明好、人流适中，一目了然。反光路段标注也让我在夜跑时更放心。推荐给所有夜跑的朋友！',
    rating: 5,
  },
  {
    id: 4,
    name: '陈思琪',
    role: '代驾司机',
    content: '做代驾最怕遇到不熟悉的路段，尤其是晚上。夜色导航的夜间专属路线帮了大忙，自动规避照明不足和路况复杂的路段。客户都说我选的路又安全又快。',
    rating: 4,
  },
];

export const stats = [
  { value: '500万+', label: '累计服务用户' },
  { value: '300+', label: '覆盖城市' },
  { value: '99.7%', label: '夜间定位准确率' },
  { value: '1200万+', label: '夜间安全导航里程(公里)' },
];